module.exports = __webpack_public_path__ + "img/9_reinhard_05.f37337aa.png";